import { Grid, Input, InputAdornment } from '@mui/material';
import * as React from 'react';
import { useIdentityContext } from '../../components/identity';
import Empty from '../../layout/Empty';
import ConnectorCard from './ConnectorCard';
import { connectorIcons, connectors, getEnvironment, connectorContent } from './ConnectorConstantData';
import ConnectDialog from './ConnectDialog';
import ConnectDialogAuthenticate from './ConnectDialogAuthenticate';
import ConfigureSalesforcesConfiguration from './ConfigureSalesforcesConfiguration';
import { NUMBER } from '../../utils/Constants/MagicNumber';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useNotify } from 'react-admin';
import '../../auth/integrations.css';

const currentOrigin = window.location.origin;
const environment = getEnvironment(currentOrigin);
const baseUrl = `https://protiv-${environment}-api.kiwi-internal.com`;
const apiUrl = `${baseUrl}/connector`;

const ConnectorList = () => {
    const [open, setOpen] = React.useState(false);
    const [openAuthenticate, setOpenAuthenticate] = React.useState(false);
    const [configurationOpen, setConfigurationOpen] = React.useState(false);
    const [connectModalContent, setConnectModalContent] = React.useState<any>({title:'',icon:''});
    const [authenticateModalContent, setAuthenticateModalContent] = React.useState<any>({title:'',icon:''});
    const [configurationModalContent, setConfigurationModalContent] = React.useState<any>({title:'',icon:''});
    const [apiKey, setApiKey] = React.useState('');
    const [configureClicked, setConfigureClicked] = React.useState(false);
    const [connectorId, setConnectorId] = React.useState('');
    const [allConnectors, setAllConnectors] = React.useState([]);
    const identity = useIdentityContext();
    const notify = useNotify();

    const getConnector = async() => {
        try {
          const response = await fetch(`${apiUrl}/?company_id=${identity?.company_id}`, {
                method: 'GET',
                headers: {
                    'accept': 'application/json'
                },
              });

              if (response.ok) {
                const responseData = await response.json();
                setAllConnectors(responseData?.results ? responseData?.results : [])
              } else {
                notify(`Unable to fetch connectors.`)
              }
            } catch (error) {
              setAllConnectors([]);
              notify(`Unable to fetch connectors ${error}`)
            }
    }

    React.useEffect(()=>{
      if(identity?.company_id){
        getConnector();
      }
    },[identity?.company_id])


    // const handleClickOpen = (data) => {
    //     setOpen(true);
    //     setConnectModalContent(data);
    // };

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpenAuthenticateModal = async (data, check) => {
      if(check){
        setOpenAuthenticate(true);
        setAuthenticateModalContent(data);
      }else{
        try {
          const payload = {is_active:false};
          const response = await fetch(`${apiUrl}/${data?.id}/status`, {
          method: 'PUT',
          headers: {
              'Content-Type': 'application/json',
             },
            body: JSON.stringify(payload),
          });
          if (response.ok) {
            getConnector();
            notify('Connection removed Successfully.')
          } else {
            notify('Unable to disconnectat at this moment.')
          }
        } catch (error) {
          notify('Unable to disconnectat at this moment.')
        }
      }
    };

    const handleCloseAuthenticateModal = () => {
        setOpenAuthenticate(false);
    };

    const handleClickOpenConfigure = (data) => {
        setConfigurationOpen(true);
        setConfigureClicked(true);
        setConfigurationModalContent(data)
        setConnectorId(data?.id ? data?.id : '');
    };

    const handleCloseConfigure = async () => {
        setConfigurationOpen(false);
    };

    // const [sortbyselect, setsortbyselect] = React.useState('');

    // const handleChange = (event: SelectChangeEvent) => {
    //   setsortbyselect(event.target.value as string);
    // };

const connectorNames = connectors?.map(connector => connector.connector);
const allConnectorNames = allConnectors?.map(connector => connector.connector);
const missingConnectorNames = connectorNames?.filter(name => !allConnectorNames?.includes(name));
const updatedConnectors = allConnectors?.concat(
  connectors.filter(connector => missingConnectorNames.includes(connector.connector))
);

    return (
        <>
            {open && <ConnectDialog open={open} handleClose={handleClose}  connectModalContent={connectModalContent} />}
            {openAuthenticate && <ConnectDialogAuthenticate setConnectorId={setConnectorId} getConnector={getConnector} open={openAuthenticate} handleCloseAuthenticate={handleCloseAuthenticateModal} handleClickOpenConfigure={handleClickOpenConfigure}
              authenticateModalContent={authenticateModalContent} apiKey={apiKey} setApiKey={setApiKey} />}
            {configurationOpen && <ConfigureSalesforcesConfiguration getAllConnector={getConnector} connectorId={connectorId} open={configurationOpen} handleCloseConfiguration={handleCloseConfigure} configurationModalContent={configurationModalContent} />}

            <div className='integration-page'>
            {/* <h2 className="main-title main-title-mobile">Integrations</h2>
            <div className='integration-toolbar'>
              <div className="propay-filter-search">
                <Input
                  placeholder="Search"
                  id="integration-search"
                  name="integration-search"
                  className="propay-search"
                  fullWidth
                />
              </div>
              <div className='integration-sort'>
                <FormControl fullWidth size='small'>
                  <InputLabel id="sort-by-select-label">Sort by</InputLabel>
                  <Select
                    labelId="sort-by-select-label"
                    id="sort-by-select"
                    value={sortbyselect}
                    label="Sort by"
                    onChange={handleChange}
                    fullWidth
                    startAdornment={
                      <InputAdornment position="start">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                          <path d="M2.5 6.75L6.25 3M6.25 3L10 6.75M6.25 3V14.25M17.5 14.25L13.75 18M13.75 18L10 14.25M13.75 18V6.75" stroke="#9B9B9B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </InputAdornment>
                    }
                  >
                    <MenuItem value={10}>Connected</MenuItem>
                    <MenuItem value={20}>A - Z</MenuItem>
                    <MenuItem value={30}>Z - A</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div> */}
                <Grid container spacing={0}>
                    {updatedConnectors?.length ? updatedConnectors?.map((connector, index) => (
                        <ConnectorCard
                            key={index}
                            connector={{...connector, ...connectorContent[connector?.connector]}}
                            icon={connectorIcons[connector?.connector]}
                            title={connectorContent[connector?.connector]?.title}
                            description={connectorContent[connector?.connector]?.description}
                            connected={connector.is_active}
                            onConnect={handleOpenAuthenticateModal}
                            onConfigure={handleClickOpenConfigure}
                            getConnector={getConnector}
                        />
                    )) : <Empty/> }
                </Grid>
            </div>
        </>
    );
};

export default ConnectorList;
